(function ($) {
  'use strict';

  console.log('account.es6');

  // ─── Intl Tel Input ───────────────────────────────────────────────────────

  const itiMap = new Map();
  const lastRawNumberMap = new Map();

  function initPhoneInput(selector) {
    const input = document.querySelector(selector);
    if (!input || input.classList.contains("iti-loaded")) return;
    input.classList.add("iti-loaded");

    if (window.intlTelInput) {
      const iti = window.intlTelInput(input, {
        initialCountry: "auto",
        separateDialCode: true,
        strictMode: true,
        customPlaceholder: (selectedCountryPlaceholder, selectedCountryData) => {
          if (!selectedCountryPlaceholder) return "";
          let placeholder = selectedCountryPlaceholder;

          if (selectedCountryData.iso2 === 'bg' && placeholder.startsWith('0')) {
            placeholder = placeholder.substring(1).trim();
          }
          return placeholder;
        },
        geoIpLookup: function (success, failure) {
          fetch("https://ipapi.co/json")
            .then((res) => res.json())
            .then((data) => success(data.country_code))
            .catch(() => {
              if (typeof success === 'function') success("bg");
              else if (typeof failure === 'function') failure();
            });
        },
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.6.0/build/js/utils.js",
      });

      itiMap.set(input, iti);
      lastRawNumberMap.set(input, "");

      input.addEventListener('input', function () {
        const itiInstance = itiMap.get(input);
        if (!itiInstance) return;

        const countryData = itiInstance.getSelectedCountryData();
        const dialCode = countryData.dialCode;

        let val = input.value;

        if (val.startsWith('+' + dialCode)) {
          val = val.substring(dialCode.length + 1).trim();
        } else if (val.startsWith(dialCode)) {
          val = val.substring(dialCode.length).trim();
        }

        input.value = val.replace(/[^\d\s-]/g, '');
        lastRawNumberMap.set(input, val);
      });

      const updateMaxLength = () => {
        const placeholder = input.getAttribute("placeholder") || "88 123 4567";
        const len = placeholder.replace(/\D/g, '').length + 4;
        input.setAttribute("maxlength", len);
      };

      input.addEventListener('countrychange', updateMaxLength);
      setTimeout(updateMaxLength, 1000);
    }
  }

  initPhoneInput("#billing_phone");

  // ─── Modal lifecycle hooks ─────────────────────────────────────────────────
  $('#modal-delete-account')
    .on('show.bs.modal', function () {
      if (window.themeUtils) window.themeUtils.lockBodyScroll();
    })
    .on('hidden.bs.modal', function () {
      if (window.themeUtils) window.themeUtils.unlockBodyScroll();
    });

  // ─── Open modal ────────────────────────────────────────────────────────────

  $('#btn-delete-account').on('click', function (e) {
    e.preventDefault();
    $('#modal-delete-account').modal('show');
  });

  // ─── Password Toggle ───────────────────────────────────────────────────────

  $(document).on('click', '.password-toggle', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var $input = $btn.siblings('input');

    if ($input.attr('type') === 'password') {
      $input.attr('type', 'text');
      $btn.addClass('is-visible');
    } else {
      $input.attr('type', 'password');
      $btn.removeClass('is-visible');
    }
  });

  // ─── Confirm delete ────────────────────────────────────────────────────────

  $('#btn-confirm-delete').on('click', function () {
    var $btn = $(this);
    $btn.prop('disabled', true).text('Deleting...');

    $.ajax({
      url: seasonic_auth_data.ajax_url,
      type: 'POST',
      data: {
        action: 'seasonic_delete_account',
        nonce: seasonic_auth_data.security_nonce,
      },
      success: function (response) {
        if (response.success) {
          // Redirect to home after successful deletion
          window.location.href = response.data.redirect;
        } else {
          $('#modal-delete-account .modal-error')
            .text(response.data.message || 'Something went wrong. Please try again.')
            .show();
          $btn.prop('disabled', false).text('DELETE');
        }
      },
      error: function () {
        $('#modal-delete-account .modal-error')
          .text('Network error. Please try again.')
          .show();
        $btn.prop('disabled', false).text('DELETE');
      }
    });
  });

  // ─── Mobile Account Menu Overlay ───────────────────────────────────────────

  const $mobileTrigger = $('#account-menu-mobile-trigger');
  const $mobileClose = $('#account-menu-mobile-close');
  const $overlayPath = '#account-navigation-overlay';
  const $overlay = $($overlayPath);

  $mobileTrigger.on('click', function (e) {
    e.preventDefault();
    if (window.themeUtils) window.themeUtils.setOverlayState($overlayPath, true);
  });

  $mobileClose.on('click', function (e) {
    e.preventDefault();
    if (window.themeUtils) window.themeUtils.setOverlayState($overlayPath, false);
  });

  // Close overlay on background click
  $overlay.on('click', function (e) {
    if ($(e.target).is($overlay)) {
      if (window.themeUtils) window.themeUtils.setOverlayState($overlayPath, false);
    }
  });

})(jQuery);

